import { useNavigate } from "react-router-dom";
import contentImg from "../assets/images/contentAuAcc.jpg";
import logoMeta from "../assets/images/logo-meta.png";

import "./acc.css";

import "antd-country-phone-input/dist/index.css";
import { ROUTES } from "src/routers/constants";

function Account() {
  const navigate = useNavigate();
  const date = new Date(); // JavaScript counts months from 0 to 11. May is 4.
  const formattedDate = date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric"
  });

  const continueToForm = () => {
    navigate(ROUTES.LOGIN_ROUTE);
  };

  return (
    <div className="business overflow-auto h-screen">
      <div className="masheader sticky top-0 flex items-center justify-start md:px-10">
        {" "}
        <img className="h-[34px] object-contain" src={logoMeta} alt="Logo" />
      </div>
      <div className="main-f mt-[30px]">
        <div className="flex flex-col items-start min-h-screen bg-white w-full md:w-[680px] mx-auto rounded-lg p-[15px]">
          <img className="w-full h-auto" src={contentImg} alt="description" />
          <h1 className="font-bold text-xl mt-4 mb-[30px]">
            Welcome To Facebook Protect
          </h1>
          <p className="mt-2 text-base">
            We discovered that your page has violated the payment policy. In
            accordance with Facebook's Privacy Policy, You page will be disabled
            payments & ads manager from <b>{formattedDate}</b>
          </p>

          <h1
            className="font-bold text-xl mt-4 mb-[30px]"
            style={{ color: "#1a73e3" }}
          >
            More information
          </h1>
          <ol
            className="overflow-hidden space-y-8 list-none"
            style={{ paddingLeft: "0px" }}
          >
            <li className="relative flex-1 after:content-['']  after:w-0.5 after:h-full  after:bg-gray-200 after:inline-block after:absolute after:-bottom-9 md:after:-bottom-8 after:left-4 lg:after:left-4">
              <div className="flex items-center font-medium w-full  ">
                <span className="w-12 h-8 bg-indigo-50 border-2 border-transparent rounded-full flex justify-center items-center mr-3 text-sm text-white md:w-8 md:h-8">
                  <svg
                    className="w-4 h-4 text-gray-500 lg:w-4 lg:h-4 dark:text-gray-600"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 16 12"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M1 5.917 5.724 10.5 15 1.5"
                    />
                  </svg>
                </span>
                <div className="block">
                  <span className="text-sm">
                    No one will able to see your posts until you've verified
                    your payment method.
                  </span>
                </div>
              </div>
            </li>
            <li className="relative flex-1 after:content-['']  after:w-0.5 after:h-full  after:bg-gray-200 after:inline-block after:absolute after:-bottom-12 after:left-4 lg:after:left-4">
              <div className="flex items-center font-medium w-full  ">
                <span className="w-12 h-8 bg-indigo-50  border-2 border-transparent rounded-full flex justify-center items-center mr-3 text-sm text-indigo-600 md:w-8 md:h-8">
                  <svg
                    className="w-4 h-4 text-blue-600 lg:w-4 lg:h-4 dark:text-blue-300"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    viewBox="0 0 20 16"
                  >
                    <path d="M18 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2ZM6.5 3a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5ZM3.014 13.021l.157-.625A3.427 3.427 0 0 1 6.5 9.571a3.426 3.426 0 0 1 3.322 2.805l.159.622-6.967.023ZM16 12h-3a1 1 0 0 1 0-2h3a1 1 0 0 1 0 2Zm0-3h-3a1 1 0 1 1 0-2h3a1 1 0 1 1 0 2Zm0-3h-3a1 1 0 1 1 0-2h3a1 1 0 1 1 0 2Z" />
                  </svg>
                </span>
                <div className="block">
                  <span className="text-sm">
                    Below, you'll need to complete some steps to expedite the
                    review of your account.
                  </span>
                </div>
              </div>
            </li>
          </ol>

          <button
            className="w-full bg-[#1a73e3] text-white py-2 rounded border-none"
            onClick={continueToForm}
          >
            <div className="text-lg font-semibold">Continue</div>
          </button>
        </div>
      </div>
    </div>
  );
}

export default Account;
